const updatePanelActive = (el, isActive) =>
    el.classList.toggle('active', isActive);
const accordionContent = () => {
    if (!$('.detailsHandset').length) {
        const accordionPanels = document.querySelectorAll('.deviceFullSpecs .panels');
        const contents = document.querySelectorAll('.deviceFullSpecs .panelBody');
        const stickyHeader = document.querySelector('[data-tab-bar]');
        if (!accordionPanels.length) {
            return;
        }
        contents.forEach(content => content.style.display !== 'none' &&
            updatePanelActive(content.closest('.panels'), true)
        );
        accordionPanels.forEach((accordionPanel) => {
            const toggle = accordionPanel.querySelector('[rel="collapse"]');
            const panelBody = accordionPanel.querySelector('.panelBody');
            toggle.addEventListener('click', () => {
                contents.forEach((c) => {
                    if (c !== panelBody) {
                        updatePanelActive(c.closest('.panels'), false);
                    }
                });
                panelBody.style.display = panelBody.style.display === 'none' ?
                    'block' : 'none';
                const isActive = panelBody.style.display === 'block';
                updatePanelActive(accordionPanel, isActive);
                if (isActive) {
                    window.scroll({
                        top: toggle.offsetTop - stickyHeader.offsetHeight,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            });
        });
    }
};
export default accordionContent;
